export default __webpack_public_path__ + "static/media/Solutions.dd25a330.md";